import { defineMessages } from 'react-intl';

export default defineMessages({
  similarExperiences: {
    id: 'experience.similarExperiences',
    defaultMessage: 'Similar experiences',
  },
  allSimilarExperiences: {
    id: 'kioskHome.allSimilarExperiences',
    defaultMessage: 'See all {count} experiences in {market}',
  },
});
